import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import { withRouter } from 'react-router-dom';
import SecurityDepositAddModalUI from './SecurityDepositAddModalUI';
class SecurityDepositAddModalSF extends Component {
	constructor(props) {
		super(props);
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			depositAmount: '',
			depositAmountError: null,
		};
	}
	render() {
		return (
			<SecurityDepositAddModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				createMode={this.props.depositAddMode}
				submitted={this.state.submitted}
				onSubmit={this.onSubmit}
				onCancelCreate={this.onCancelCreate}
				depositAmount={this.state.depositAmount}
				onDepositAmountChange={(event) => this.setState({ depositAmount: event.target.value })}
				depositAmountError={this.state.depositAmountError}
				setDepositAmountError={(error) => this.setState({ depositAmountError: error })}
			/>
		);
	}
	componentDidMount() {
		Modal.setAppElement('body');
	}
	onCancelCreate = () => {
		this.setState({
			submitted: false,
			errorList: null,
		});
		this.props.onCancelCreate();
	}
	onSubmit = () => {
		if (this.state.submitted) return;
		const { depositAmount } = this.state;
		if (!depositAmount) {
			this.setState({
				depositAmountError: !depositAmount ? 'Security Deposit is required' : null,
				submitted: false,
			});
			return;
		}
		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true,
		});
		RestApiUtils.put(
			this.props.context,
			`/api/su/accounts/${this.props.account.accountId}/securityDeposit`,
			this.onSubmitCallback,
			{
				depositAmountF: this.state.depositAmount,
			}
		);
	}
	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			errorList = response.errorList.map((error) => error.message);
		}
		this.setState({
			successMsg: response.success || null,
			errorList: errorList,
			submitted: false,
		});
		if (errorList.length === 0) {
			setTimeout(() => {
				this.setState({ successMsg: null });
				this.props.onCancelCreate();
				this.props.onRefreshClick();
			}, 1000);
		}
	}
	setErrorList = (errorList) => {
		this.setState({ errorList: errorList });
	}
}
export default withRouter(SecurityDepositAddModalSF);